import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import EventBus from "common/EventBus";
import { useAuth } from "contexts/AuthContext";

import logo from "logo.svg";


var ps;

function AdminSidebar(props) {
  const { logout, user } = useAuth();
  const location = useLocation();
  const sidebar = React.useRef();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    if (user) {
      setCurrentUser(user);
      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [user]);

  const logOut = () => {
    logout();
    setShowAdminBoard(false);
    setCurrentUser(undefined);
  };
 





  return (
    <div
      className="sidebar"
        // data-color={props.bgColor}
      data-active-color={props.activeColor}
      
      data-color="black"
    >
      <div className="logo">
        <a
          href="google.com"
          className="simple-text logo-mini"
        >
          <div className="logo-img">
            <img src={logo} alt="react-logo" />
          </div>
        </a>
        <a
          href="https://www.google.com"
          className="simple-text logo-normal"
        >
          AMC
        </a>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.routes
            .filter(route => !route.hidden) // Filter out hidden routes
            .map((prop, key) => {
            return (
              <li
                className={
                  activeRoute(prop.path) + (prop.logout ? " active-pro" : "")
                }
                key={key}
              >
                <NavLink to={prop.layout + prop.path} className="nav-NavLink">
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </NavLink>
                
              </li>
            );
          })}
          <li className="logout-style">
            <NavLink to={"/"} onClick={logOut}>
              <i className="fa-solid fa-arrow-right-from-bracket log-icon"></i>
              <p className="red-log">Log Out</p>
            </NavLink>
          </li>
        </Nav>
        
      </div>
    </div>
  );
}

export default AdminSidebar;
